import { CreditCard, AlertTriangle } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { formatCurrency, toBaseCurrency, getCurrencySymbol } from "../../lib/utils";

// "3 vendas · 1 recebimento" — o talão de fecho do TPA inclui vendas E recebimentos/cartões pagos no terminal
export const tpaCountLabel = (t) => {
  const sales = t.sales ?? t.count ?? 0;
  const entries = t.entries ?? 0;
  const parts = [`${sales} venda${sales === 1 ? "" : "s"}`];
  if (entries) parts.push(`${entries} recebimento${entries === 1 ? "" : "s"}`);
  return parts.join(" · ");
};

// Fecho de caixa: valor de fecho de cada TPA (talão de fecho do terminal) vs. esperado pelo sistema
export const TPACloseInputs = ({ tpas, values, onChange }) => {
  if (!tpas?.length) return null;
  const withId = tpas.filter((t) => t.tpa_id);
  const noTpa = tpas.find((t) => !t.tpa_id);
  const systemTotal = tpas.reduce((s, t) => s + (t.expected || 0), 0);
  return (
    <div className="space-y-2 rounded-md border p-3" data-testid="tpa-close-inputs">
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-semibold flex items-center gap-1.5"><CreditCard className="w-3.5 h-3.5 text-blue-500" /> Fecho dos TPA — introduza o total do talão de fecho de cada terminal *</p>
        <span className="text-[11px] text-muted-foreground whitespace-nowrap">total cartão: <span className="font-mono" data-testid="tpa-close-system-total">{formatCurrency(systemTotal)}</span></span>
      </div>
      {withId.map((t) => {
        const v = values[t.tpa_id];
        const diff = v !== undefined && v !== "" ? toBaseCurrency(v) - t.expected : null;
        return (
          <div key={t.tpa_id} className="space-y-1" data-testid={`tpa-close-row-${t.tpa_id}`}>
            <div className="flex justify-between text-xs">
              <Label className="text-xs">{t.name}{t.bank_name ? <span className="text-muted-foreground"> · {t.bank_name}</span> : null}</Label>
              <span className="text-muted-foreground">sistema: <span className="font-mono" data-testid={`tpa-close-expected-${t.tpa_id}`}>{formatCurrency(t.expected)}</span> ({tpaCountLabel(t)})</span>
            </div>
            <Input type="number" step="0.01" min="0" value={v ?? ""} onChange={(e) => onChange({ ...values, [t.tpa_id]: e.target.value })} placeholder={`Total do fecho do TPA (${getCurrencySymbol()})`} className="font-mono h-9" data-testid={`tpa-close-input-${t.tpa_id}`} />
            {diff !== null && !isNaN(diff) && (
              <p className={`text-[11px] font-semibold ${diff < 0 ? "text-red-600" : diff > 0 ? "text-emerald-600" : "text-muted-foreground"}`} data-testid={`tpa-close-diff-${t.tpa_id}`}>
                Diferença: {diff > 0 ? "+" : ""}{formatCurrency(diff)}{diff === 0 ? " · confere" : ""}
              </p>
            )}
          </div>
        );
      })}
      {noTpa && (
        <p className="flex items-start gap-1.5 text-[11px] text-amber-600 rounded-md bg-amber-500/10 p-2" data-testid="tpa-close-no-tpa">
          <AlertTriangle className="w-3.5 h-3.5 shrink-0 mt-0.5" />
          <span>Cartão sem TPA identificado: <span className="font-mono font-semibold">{formatCurrency(noTpa.expected)}</span> ({tpaCountLabel(noTpa)}) — some este valor ao TPA onde foi passado.</span>
        </p>
      )}
    </div>
  );
};
